import { Style, Stroke } from 'ol/style';
import Icon from 'ol/style/Icon';
import OSM from 'ol/source/OSM';
import TileLayer from 'ol/layer/Tile';

import UserSessionDataHandler from 'auth/UserSessionsDataHandler';
import {
  addFeaturesToLayer,
  clearMapLayer,
  createFeatureUsingGeojsonGeometry,
  createLayer,
  createVectorSourceUsingGeojsonGeometry,
  getLayerByName,
} from 'utils/map/layers';
import { tileServerUrl } from 'consts/config';
import {
  TRANSMISSION_TOWERS_DATA,
  TRANSMISSION_TOWERS_LAYER_NAME,
} from 'consts/transmissionTowers';

const jurisdictionLayerStyle = new Style({
  stroke: new Stroke({
    color: 'blue',
    width: 3,
  }),
});

const jurisdictionWithBufferLayerStyle = new Style({
  stroke: new Stroke({
    color: 'blue',
    width: 1,
  }),
});

const createLayerForJurisdiction = () => {
  const vectorLayer = createLayer('jurysdictionLayer');
  addJurysdictionsFeaturesToLayer(vectorLayer);

  return vectorLayer;
};

const addJurysdictionsFeaturesToLayer = layer => {
  const jurysdiction = UserSessionDataHandler.getJurisdiction();
  const jurysdictionWithBuffer = UserSessionDataHandler.getJurisdictionWithBuffer();
  if (!jurysdiction || !jurysdictionWithBuffer) return;
  const jurysdictionFeature = createFeatureUsingGeojsonGeometry(jurysdiction);
  const withBuffer = createFeatureUsingGeojsonGeometry(jurysdictionWithBuffer);

  withBuffer.setId('jurysdictionWithBuffer');
  jurysdictionFeature.setId('jurysdiction');

  jurysdictionFeature.setStyle(jurisdictionLayerStyle);
  withBuffer.setStyle(jurisdictionWithBufferLayerStyle);
  addFeaturesToLayer(layer, [jurysdictionFeature, withBuffer]);
};

export const updateJurysdiction = map => {
  const layer = getLayerByName(map, 'jurysdictionLayer');
  clearMapLayer(layer);

  addJurysdictionsFeaturesToLayer(layer);
};

const getJurisdictionExtent = () => {
  const jurisdiction = UserSessionDataHandler.getJurisdictionWithBuffer();

  const vectorSource = createVectorSourceUsingGeojsonGeometry(jurisdiction);

  return vectorSource?.getExtent();
};

const setNewTokenInUserConf = data => {
  UserSessionDataHandler.saveToken(data.access);
  UserSessionDataHandler.saveRefreshToken(data.refresh);
};

const mappingTableParser = mappingTable => {
  const parsedObj = {};
  for (const eachTypeOfUavo of mappingTable) {
    const svg = `data:image/svg+xml;utf8,${encodeURIComponent(
      eachTypeOfUavo.svg
    )}`;
    parsedObj[eachTypeOfUavo.integral_type] = svg;
  }
  return parsedObj;
};

const getNumberOfLayerTypeOnMap = (map, layerName) =>
  map
    .getLayers()
    .getArray()
    .filter(eachLayer => eachLayer.getProperties().layerName === layerName)
    .length;

const returnMapLayer = mapType => {
  const chosenMapLayer = new TileLayer({
    opacity: 1,
    source: new OSM({
      url: tileServerUrl(mapType),
    }),
  });
  chosenMapLayer.setProperties({ layerName: 'tileLayer' });

  return chosenMapLayer;
};

const returnWeatherLayer = () => {
  const chosenMapLayer = new TileLayer({
    opacity: 0.7,
  });
  chosenMapLayer.setProperties({ layerName: 'weatherLayer' });

  return chosenMapLayer;
};

const towerStyle = new Style({
  image: new Icon({
    src: '/icons/transmission-tower.svg',
    scale: 0.45,
    color: 'rgba(220, 50, 50, 1)',
  }),
});

const createLayerForTransmissionTowers = () => {
  const vectorLayer = createLayer(TRANSMISSION_TOWERS_LAYER_NAME);
  const features = TRANSMISSION_TOWERS_DATA.features.map(featureData => {
    const feature = createFeatureUsingGeojsonGeometry(featureData);
    feature.setProperties({
      detail: 'transmissionTower',
      name: featureData.properties.DRUGA_NAZWA,
    });
    feature.setStyle(towerStyle);
    return feature;
  });
  addFeaturesToLayer(vectorLayer, features);
  return vectorLayer;
};

export {
  getJurisdictionExtent,
  // addBufferToExtent,
  createLayerForJurisdiction,
  createLayerForTransmissionTowers,
  setNewTokenInUserConf,
  mappingTableParser,
  getNumberOfLayerTypeOnMap,
  returnMapLayer,
  returnWeatherLayer,
};
